import { useCallback, useEffect, useState } from 'react';
import { MdExpandMore } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import CardView from '../../..';
import { activateLoading, deactivateLoading } from 'GeminiViewerComponent/features/globals/loadingProgressSlice';
import { fetchMoreAssets } from 'features/assets/assetsTableSlice';

const NoneCategoryAssetCard = ({
    searchString,
    isLoadingAssets,
    readOnlyMode,
    assetType,
    assetPayload,
    setAssetPayload,
    selectedAssetCategory,
    expanded,
    handleOpenCategory,
    singleCategory = false,
}) => {
    //#region Constants
    const dispatch = useDispatch();
    //#endregion Constants

    //#region Hooks
    //#endregion Hooks

    //#region State
    const [filteredAssets, setFilteredAssets] = useState([]);
    const [filteredAssetsPageInfo, setFilteredAssetsPageInfo] = useState({});
    //#endregion State

    //#region Selectors
    //#endregion Selectors

    //#region Refs
    //#endregion Refs

    //#region Effects
    useEffect(() => {
        fetchCategoryAsset();
    }, [assetType, assetPayload, searchString]);

    //#endregion Effects

    //#region Methods
    const fetchCategoryAsset = useCallback(async () => {
        await dispatch(activateLoading());
        const categoriesAssets = await dispatch(
            fetchMoreAssets({
                startIndex: 0,
                stopIndex: 14,
                searchString: searchString,
                assetCategoryId: 0,
                ...assetPayload,
            })
        );
        setFilteredAssetsPageInfo(categoriesAssets.payload?.pageInfo);
        setFilteredAssets(categoriesAssets.payload?.assets);
        await dispatch(deactivateLoading());
    }, [searchString, assetPayload]);
    //#endregion Methods

    //#region Render time calcs
    //#endregion Render time calcs

    //#region Render
    return (
        filteredAssets &&
        filteredAssets?.length > 0 &&
        (singleCategory ? (
            <CardView
                assets={filteredAssets}
                pageInfo={filteredAssetsPageInfo}
                searchString={searchString}
                isLoadingAssets={isLoadingAssets}
                readOnly={readOnlyMode}
                assetType={assetType}
                assetPayload={assetPayload}
                setAssetPayload={setAssetPayload}
                accordianGrid={true}
                headerDisplay={false}
                categoryId={0}
                setFilteredAssets={setFilteredAssets}
            />
        ) : (
            <Accordion id="category-0" expanded={expanded.some((cat) => cat === 0)} onChange={handleOpenCategory(0)}>
                <AccordionSummary
                    sx={{
                        backgroundColor: '#efefef',
                    }}
                    expandIcon={<MdExpandMore />}
                >
                    NONE
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '8px !important' }}>
                    <Box
                        id="assetCards-0"
                        sx={{
                            overflow: 'auto !important',
                        }}
                    >
                        <CardView
                            assets={filteredAssets}
                            pageInfo={filteredAssetsPageInfo}
                            searchString={searchString}
                            isLoadingAssets={isLoadingAssets}
                            readOnly={readOnlyMode}
                            assetType={assetType}
                            assetPayload={assetPayload}
                            setAssetPayload={setAssetPayload}
                            accordianGrid={true}
                            headerDisplay={false}
                            categoryId={0}
                            setFilteredAssets={setFilteredAssets}
                        />
                    </Box>
                </AccordionDetails>
            </Accordion>
        ))
    );
    //#endregion Render
};

export { NoneCategoryAssetCard };
